import { Component, OnInit, Input } from '@angular/core';
import { PaymentMethod } from '../../../core/models/company';
import { PaymentsType } from '../../../core/models/payments-type';
import { CompanyParamsService } from '../../../core/services/company-params.service';
import { PaymentsTypeService } from '../../services/payments-type.service';
import { isNullOrUndefined } from 'is-what';
import { NgIf, NgStyle, NgFor } from '@angular/common';

@Component({
    selector: 'app-info-payments',
    templateUrl: './info-payments.component.html',
    styleUrls: ['./info-payments.component.scss'],
    imports: [NgIf, NgStyle, NgFor]
})
export class InfoPaymentsComponent implements OnInit {
  @Input() hasFaq: boolean = false;
  @Input() hasSloganPrice: any;
  @Input() hasPaymentsIcons: boolean = false;
  //paymentsIcons: PaymentsType[];
  paymentsIcons: any[];
  paymentMethods: PaymentMethod[];
  constructor(
    public companyParamsService: CompanyParamsService,
    private paymentsTypeService: PaymentsTypeService
  ) {
    this.paymentsIcons = [];
    this.paymentMethods = companyParamsService.getPaymentMethods();
  }

  ngOnInit() {
    this.paymentMethods.forEach((item) => { });
    this.paymentsIcons = this.getImagesByName();
  }
  getImagesByName(): PaymentsType[] {
    // let listImagesNames: string[] = [];
    let listImagesNames: any[] = [];

    if (this.paymentMethods.length > 0) {
      this.paymentMethods.forEach((item: any) => {
        if (item.icons && item.icons.length > 0) {
          item.icons.forEach((itemIcons: any) => {
            //console.log(itemIcons);
            const isAlreadyRendered = listImagesNames.some(
              (icon: any) => icon.img === itemIcons.img
            );
            if (!isAlreadyRendered) {
              listImagesNames.push(itemIcons);
            }

          });
        }
      });
    }

    return listImagesNames;
  }

  validateImgPath(path: string) {
    return !isNullOrUndefined(path) && path.length != 0;
  }
}
